// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"abaa8c3d3d7a2d4e1d80","873":"a3a22b89e3fe64151d98"}[chunkId] + ".js";
};